module.exports = __webpack_public_path__ + "amcharts/images/pencilIcon.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/pencilIcon.svg
// module id = 278
// module chunks = 0